import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-059c4de8")

_pushScopeId("data-v-059c4de8")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "top-button-group flex alignC" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增项目", -1)
const _hoisted_4 = { class: "mar-l-8 mar-t-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "状态", -1)
const _hoisted_6 = { class: "mar-l-8 mar-t-12" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "分类", -1)
const _hoisted_8 = { class: "flex button-group" }
const _hoisted_9 = { class: "c-red" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "配件管理", -1)
const _hoisted_11 = { class: "flex flexR mar-t-22" }
const _hoisted_12 = {
  key: 0,
  class: "media"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "store img upload-demo media__body" }, " 上传 ", -1)
const _hoisted_14 = {
  key: 1,
  class: "el-icon-plus store-uploader-icon"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("p", {
  class: "c-90",
  "label-width": "80px"
}, " 只能上传 jpg/png 文件，且不超过 500kb ", -1)
const _hoisted_16 = { class: "flex alignC" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-center c-red" }, "（排序越小越靠前）", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "c-30" }, "元", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "c-30" }, "元", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "c-30" }, "元", -1)
const _hoisted_21 = { class: "flex flexSb bonus" }
const _hoisted_22 = { class: "c-30" }
const _hoisted_23 = { class: "c-30" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { style: {"padding":"0 50px"} }, [
  /*#__PURE__*/_createVNode("div", { id: "editor" })
], -1)
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = { class: "c-ff" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "取 消", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.create)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "bg-red mar-r-18 mar-t-12",
            onClick: _ctx._add
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_select, {
          style: {"width":"108px"},
          placeholder: "请选择",
          modelValue: _ctx.selectGroup.status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectGroup.status = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'status'))),
          clearable: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "启用",
              value: 1
            }),
            _createVNode(_component_el_option, {
              label: "禁用",
              value: 2
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_select, {
          style: {"width":"108px"},
          placeholder: "请选择",
          modelValue: _ctx.selectGroup.project_type_pid,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectGroup.project_type_pid = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenChange($event, 'mountings_type_id'))),
          clearable: ""
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_list, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: item.name,
                value: item.id,
                key: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.selectGroup.search,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectGroup.search = $event)),
        placeholder: "关键字",
        clearable: "",
        "suffix-icon": "el-icon-search",
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenChange($event,'search'))),
        class: "mar-t-12 mar-l-8"
      }, null, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          align: "center",
          label: "图片",
          "min-width": "100"
        }, {
          default: _withId((scope) => [
            _createVNode("img", {
              src: scope.row.img.url,
              alt: "",
              style: {"width":"56px","height":"36px"}
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_8, [
              (_ctx.roleList.edit)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, true))
                  }, {
                    default: _withId(() => [
                      _createVNode("span", _hoisted_9, _toDisplayString(scope.row.status == 0 ? "详情" : "编辑"), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.roleList.manage)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: ($event: any) => (_ctx.partsManage(scope.row.id))
                  }, {
                    default: _withId(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.roleList.disable)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    onClick: ($event: any) => (_ctx.columnChange(scope.row, false))
                  }, {
                    default: _withId(() => [
                      _createVNode("span", {
                        class: scope.row.status == 2?'c-99':'c-red'
                      }, _toDisplayString(scope.row.status == 2 ? "启用" : "禁用"), 3)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialog_title,
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      center: "",
      width: 1000
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_25, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.submitForm
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_26, _toDisplayString(_ctx.dialog_title == '编辑' ? "保存" : "立即创建"), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_27
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "服务名称",
              prop: "name",
              "label-width": "120px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  class: "dialog-input",
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.name = $event)),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "服务图片",
                prop: "img",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_upload, {
                    class: "upload-demo",
                    action: "https://jsonplaceholder.typicode.com/posts/",
                    "show-file-list": false,
                    "before-upload": _ctx.beforeAvatarUpload,
                    "on-change": (file, fileList) => {_ctx.handleChange(file, false);}
                  }, {
                    tip: _withId(() => [
                      _hoisted_15
                    ]),
                    default: _withId(() => [
                      (_ctx.img.key)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            _withDirectives(_createVNode("img", {
                              src: _ctx.img.url,
                              class: "store img media__image",
                              onLoad: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.imgLoad && _ctx.imgLoad(...args)))
                            }, null, 40, ["src"]), [
                              [_directive_loading, _ctx.imgLoading]
                            ]),
                            _hoisted_13
                          ]))
                        : (_openBlock(), _createBlock("i", _hoisted_14))
                    ]),
                    _: 1
                  }, 8, ["before-upload", "on-change"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "服务分类",
                prop: "project_type_pid",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"270px"},
                    class: "mar-r-18",
                    modelValue: _ctx.form.project_type_pid,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.project_type_pid = $event)),
                    placeholder: "请选择",
                    onChange: _ctx.formSelectProjectTypeChange
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.select.project_type_list, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.name,
                          value: item.id,
                          key: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "显示在用户端",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_checkbox, {
                    "true-label": 1,
                    "false-label": 0,
                    modelValue: _ctx.form.is_show,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.is_show = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, {
                label: "排序",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "number",
                    modelValue: _ctx.form.sort,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.sort = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_17
            ]),
            _createVNode("div", null, [
              (_ctx.is_admin)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "适用门店",
                    prop: "store_ids",
                    "label-width": "120px"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.store_ids,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.store_ids = $event)),
                        multiple: "",
                        placeholder: ""
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.store_ids, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.store_name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", null, [
              _createVNode(_component_el_form_item, {
                label: "工时费（低）",
                prop: "low_price",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-90",
                    modelValue: _ctx.form.low_price,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.low_price = $event)),
                    autocomplete: "off"
                  }, {
                    suffix: _withId(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "工时费（中）",
                prop: "middle_price",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-90",
                    modelValue: _ctx.form.middle_price,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.middle_price = $event)),
                    autocomplete: "off"
                  }, {
                    suffix: _withId(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "工时费（高）",
                prop: "high_price",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    class: "width-90",
                    modelValue: _ctx.form.high_price,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.high_price = $event)),
                    autocomplete: "off"
                  }, {
                    suffix: _withId(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_el_form_item, {
                label: "施工提成",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    class: "dialog-select-min",
                    modelValue: _ctx.form.build_bonus_type,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.build_bonus_type = $event)),
                    placeholder: "请选择",
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.bonusSelectChange(true)))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item,
                          value: index + 1,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input, {
                    class: "dialog-input-min",
                    modelValue: _ctx.form.build_bonus_price,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.build_bonus_price = $event))
                  }, {
                    suffix: _withId(() => [
                      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.form.build_bonus_type == 1 ? "元" : "%"), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "销售提成",
                "label-width": "120px"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    class: "dialog-select-min",
                    modelValue: _ctx.form.sell_bonus_type,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.sell_bonus_type = $event)),
                    placeholder: "请选择",
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.bonusSelectChange(false)))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commissionType, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item,
                          value: index + 1,
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_input, {
                    class: "dialog-input-min",
                    modelValue: _ctx.form.sell_bonus_price,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.sell_bonus_price = $event))
                  }, {
                    suffix: _withId(() => [
                      _createVNode("span", _hoisted_23, _toDisplayString(_ctx.form.sell_bonus_type == 1 ? "元" : "%"), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _hoisted_24
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})